import styled from '@emotion/styled'
import { HStack, Stack } from 'components/Stack'
import { BREAKPOINTS, pxToRemUnit } from 'utils/styled'
import { Text } from 'components/Typography'

export const PlanPerksContainer = styled(Stack)`
  padding: 0 1rem;
`

export const PerkCardsContainer = styled(HStack)`
  justify-content: center;
  @media ${BREAKPOINTS.MD.max} {
    flex-direction: column;
    > div:not(:last-child) {
      margin-right: 0;
      margin-bottom: 1rem;
    }
  }
`

export const SStack = styled(Stack)`
  text-align: center;
  align-items: center;
  @media ${BREAKPOINTS.MD.max} {
    text-align: start;
    align-items: flex-start;
  }
`

export const WidthControlledText = styled(Text)`
  max-width: ${pxToRemUnit(475)};
  @media ${BREAKPOINTS.MD.max} {
    font-size: 0.875rem;
  }
`
